import React from 'react'
import root from './utils'

const TitledBulletPoint = ({title, description}) => {
  let greenCheckFlat = root + '/common/latest/images/consumer/order-process-icons/green-check.png'

  return (
    <div>
      <div className='row'>
        <div className='col-xs-1'>
          <img role='presentation' src={greenCheckFlat} />
        </div>
        <div className='col-xs-10'>
          <strong>{title}</strong>
        </div>
      </div>
      <div className='row'>
        <div className='col-xs-1' />
        <div className='col-xs-10'>
          <h5 className='row' style={{fontFamily: 'Roboto',  fontSize: 14, lineHeight: '17px', fontWeight: 300}}>{description}</h5>
        </div>
      </div>
    </div>
  )
}

export default TitledBulletPoint



// WEBPACK FOOTER //
// ./src/components/shared/titled-bullet-point.jsx